export const MAX_IDLE_TIME = 60; // in minutes
export const IDLE_TIME_INTERVAL = 1000; // in milliseconds
